//Get Badge
export const GET_BADGE = "GET_BADGE";

//Insert Badge
export const INSERT_BADGE = "INSERT_BADGE";

//Update Badge
export const UPDATE_BADGE = "UPDATE_BADGE";

//Delete Badge
export const DELETE_BADGE = "DELETE_BADGE";

//Insert Open Dialog
export const OPEN_BADGE_DIALOG = "OPEN_BADGE_DIALOG";

//Close Dialog
export const CLOSE_DIALOG = "CLOSE_DIALOG";

//toast
export const OPEN_BADGE_TOAST = "OPEN_BADGE_TOAST";
export const CLOSE_BADGE_TOAST = "CLOSE_BADGE_TOAST";

//Metrics Dialog
export const OPEN_METRICS_DIALOG = "OPEN_METRICS_DIALOG";
export const CLOSE_METRICS_DIALOG = "CLOSE_METRICS_DIALOG";

//Update Badge Metrics
export const UPDATE_BADGE_METRICS = "UPDATE_BADGE_METRICS";